import React from "react";
import l from "components/util/l";

// The clip, and what it opens. With a single option there is nothing to choose, so the
// clip goes straight to it and no menu is painted.
const ConversationAttachmentMenu = ({
  count = 0,
  options = [],
  isDisabled = false,
  onSelectOption,
}) => {

  if (options.length == 0) return null;

  const badge = count > 0 && <span className="attach-count">{count}</span>;

  if (options.length == 1)
    return (
      <button type="button"
        className="fas fa-paperclip attach"
        disabled={isDisabled}
        title={options[0].label}
        onClick={() => onSelectOption(options[0])}>
        {badge}
      </button>
    );

  return (
    <div className="btn-group dropup attach-menu">

      <button type="button"
        className="fas fa-paperclip attach"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        disabled={isDisabled}
        title={l("Adjuntar%CH011")}>
        {badge}
      </button>

      <div className="dropdown-menu dropdown-menu-right py-2">
        {options.map((option) =>
          <button key={option.id}
            type="button"
            className="dropdown-item d-flex align-items-center"
            onClick={() => onSelectOption(option)}>
            <i className={`fas ${option.icon} dropdown-item-icon my-0 py-0`}
              style={{ color: option.color }} />
            {option.label}
          </button>
        )}
      </div>

    </div>
  );

}

export default ConversationAttachmentMenu;
